import { render } from "./PaginationRange.vue?vue&type=template&id=5d272f99&scoped=true"
import script from "./PaginationRange.vue?vue&type=script&lang=js"
export * from "./PaginationRange.vue?vue&type=script&lang=js"

import "./PaginationRange.vue?vue&type=style&index=0&id=5d272f99&scoped=true&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d272f99"]])

export default __exports__